import type * as React from 'react';
import { injectIntl } from 'react-intl';
import type { WrappedComponentProps } from 'react-intl';

import { Styled } from './tooltip.style';

export type ToolTipProps = WrappedComponentProps & {
  id: string;
  onClick?: () => void;
  children: React.ReactNode;
};

const ToolTipWithIntl: React.FC<ToolTipProps> = ({
  id,
  intl,
  onClick,
  children,
}) => {
  const name: string = intl.formatMessage({ id, defaultMessage: '' });

  return (
    <Styled.ToolTip
      onClick={onClick}
      title={name}
      aria-label={name}
      role="tooltip"
    >
      {children}
    </Styled.ToolTip>
  );
};

export const ToolTip = injectIntl(ToolTipWithIntl);
